/**
 * Links that always resolve on the platform apex, never inside a brand.
 *
 * A brand is served either by path (`bioterapias.cl/<slug>/...`) or by
 * subdomain (`<slug>.bioterapias.cl`). In both cases the SPA history base keeps
 * internal `router-link`s inside the brand, so `{ name: 'login' }` resolves to
 * `bioterapias.cl/<slug>/login` or `<slug>.bioterapias.cl/login`. Authentication
 * is centralised on the apex -- one endpoint (`POST /users/login`) and one
 * identity store (`public.users`) -- so the professional-access entry has to
 * leave the brand and land on the single apex login.
 *
 * `siteDomain()` is the bare platform host and never a brand's own subdomain,
 * which is exactly the apex these links are built from.
 */
import { siteDomain } from '@/services/seo/serviceSeo';

export function apexBaseUrl(): string {
  return `https://${siteDomain()}`;
}

export function apexLoginUrl(): string {
  return `${apexBaseUrl()}/login`;
}
